<template>
  <ItemTableActionBarHeaderMessage
    level="warn"
    linkText="view"
    :message="unmanagedMessage"
    messageHeader="User Enrolled Devices"
  >
    <ButtonLink
      v-if="showViewLink"
      data-test-id="UnmanagedDevicesBanner__view"
      text="view"
      @click="handleClick()"
    />
  </ItemTableActionBarHeaderMessage>
</template>

<script>
import {
  ButtonLink,
} from '@jumpcloud/ui-components';
import ItemTableActionBarHeaderMessage from 'client/components/ItemTable/ItemTableActionBarHeaderMessage.vue';
import pluralize from 'pluralize';

export default {
  name: 'UnmanagedDevicesBanner',

  components: {
    ButtonLink,
    ItemTableActionBarHeaderMessage,
  },

  props: {
    currentTabIndex: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
  },

  computed: {
    showViewLink() {
      return (this.currentTabIndex !== 2);
    },
    unmanagedMessage() {
      return `- ${this.totalCount} ${pluralize('devices', this.totalCount)} ${pluralize('has', this.totalCount)} been enrolled through the user portal and ${pluralize('is', this.totalCount)} pending administrative action.`;
    },
  },

  methods: {
    async handleClick() {
      this.$emit('click', 2);
    },
  },
};
</script>
